import React from "react";

const Tabs = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M0.75 15.75L2.83969 8.78439C2.88627 8.62919 2.98187 8.49325 3.11217 8.39692C3.24247 8.30059 3.40046 8.24905 3.5625 8.25001H11.4469C11.6081 8.25006 11.765 8.30206 11.8944 8.39832C12.0238 8.49458 12.1186 8.62996 12.165 8.78439L14.25 15.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 8.25H15.9422C16.1034 8.25005 16.2604 8.30205 16.3897 8.39831C16.5191 8.49456 16.614 8.62994 16.6603 8.78437L18.75 15.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5 8.25H20.4422C20.6034 8.25005 20.7604 8.30205 20.8897 8.39831C21.0191 8.49456 21.114 8.62994 21.1603 8.78437L23.25 15.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.75 15.75H23.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Tabs;
